import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-hot-toast";
import { BiLoaderCircle } from "react-icons/bi";
import { FiUploadCloud } from "react-icons/fi";
import axios from "axios";
import { baseURL } from "../../configs/axiosConfig";
import { useSelector } from "react-redux";

const Uploader = ({ refreshFunction }) => {
  const { user } = useSelector((state) => state.user);
  const [isUploading, setIsUploading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [imagePreview, setImagePreview] = useState("");
  const [avatar, setAvatar] = useState(null);

  const uploadS3Image = async (file) => {
    if (
      !file ||
      !["image/jpeg", "image/jpg", "image/png"].includes(file.type)
    ) {
      return toast.error("Invalid image format. Only jpg, jpeg, png allowed.");
    }

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const xhr = new XMLHttpRequest();

      xhr.open("POST", `${baseURL}/api/products/uploadImageS3`, true);

      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round(
            (event.loaded / event.total) * 100,
          );
          setUploadProgress(percentComplete);
        }
      });

      // Handle success
      xhr.onload = async () => {
        setIsUploading(false);
        if (xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          if (res.success) {
            setImagePreview(res.location); // Preview image URL from S3 response
            setAvatar(file);
            refreshFunction && refreshFunction(res.location);
            toast.success("Image uploaded successfully");
          } else {
            toast.error("Failed to upload image");
          }
        } else {
          toast.error("Failed to upload image");
        }
      };

      // Handle error
      xhr.onerror = () => {
        toast.error("Failed to upload image");
        setIsUploading(false);
      };

      // Send request
      xhr.send(formData);
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Something went wrong");
      setIsUploading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setAvatar(file);
    uploadS3Image(file);
  };

  // upload file
  const onDrop = useCallback(async (acceptedFiles) => {
    toast.error("This feature is not available yet");
  }, []);

  return (
    <div className="w-full text-center grid grid-cols-12 gap-4">
      <label className="px-6 lg:col-span-10 sm:col-span-8 col-span-12 pt-5 pb-6 border-2 border-dashed rounded-md cursor-pointer block text-center">
        <input
          type="file"
          name="photo"
          accept="image/jpeg,image/jpg,image/png"
          onChange={handleFileChange}
          className="hidden"
        />
        <span className="mx-auto flex justify-center">
          <FiUploadCloud className="text-3xl text-yellowdark" />
        </span>
        <p className="text-sm mt-2">Drag your image here</p>
        <em className="text-xs text-gray-400">
          (Only *.jpeg and *.png images will be accepted)
        </em>
      </label>
      {/* image preview */}
      <div className="lg:col-span-2 sm:col-span-4 col-span-12 flex items-center justify-center">
        {isUploading ? (
          <div className="flex flex-col items-center justify-center h-36 gap-2">
            <p>Uploading....</p>
            <div className="w-full bg-gray-300 h-1 rounded-md overflow-hidden">
              <div
                className="h-full bg-yellow-700 transition-all"
                style={{ width: `${uploadProgress}%` }}
              />
            </div>
          </div>
        ) : imagePreview || user?.photo ? (
          <img
            src={imagePreview || user.photo}
            alt="preview"
            className="w-36 h-36 rounded-xl object-cover p-1 m-auto"
          />
        ) : (
          <div className="w-36 h-36 rounded-xl bg-neonYellow text-navy flex items-center justify-center text-3xl font-bold">
            {(user?.displayName || user?.username || "U")
              .slice(0, 2)
              .toUpperCase()}
          </div>
        )}
      </div>
    </div>
  );
};

export default Uploader;
